import { FC } from 'react';
import * as styles from './SecondaryNavItem.styles';
import { SecondaryNavItemVariants } from 'components/SecondaryNav/SecondaryNav.enums';
import { SecondaryNavItemProps } from 'components/SecondaryNav/SecondaryNav.types';
import Icon from 'yoda-ui/components/Icons/Icon';
import LinkButton from 'yoda-ui/components/Links/LinkButton';
import ListItem from 'yoda-ui/components/List/ListItem';
import ListItemText from 'yoda-ui/components/List/ListItemText';

const SecondaryNavItem: FC<SecondaryNavItemProps> = (props) => {
  const { CONTENT, HEAD } = SecondaryNavItemVariants;
  const { icon, text, onClick = () => {}, selected, variant = CONTENT } = props;

  const variantStyle = variant === HEAD ? styles.NavLinkHead : styles.NavLink;
  const activeStyle = variant === CONTENT && selected ? styles.NavLinkActive : {};

  if (!icon && !text) {
    return null;
  }

  return (
    <ListItem disablePadding>
      <LinkButton onClick={ onClick } sx={ { ...variantStyle, ...activeStyle } }>
        { icon && <Icon name={ icon } sx={ styles.ItemIcon } /> }
        { text && <ListItemText disableTypography primary={ text } sx={ styles.ItemText } /> }
      </LinkButton>
    </ListItem>
  );
};

export default SecondaryNavItem;
